import React from "react";
import AddIcon from "@mui/icons-material/Add";
import { validityText } from "./PackageDetailsModal";
import "../Members/members.css";

// "Predhodne termine" is a real `packages.name` value in the DB — the legacy-backfill
// placeholder package created for clients whose historical bookings were migrated in without a
// real purchased package (0 sessions, no real price). Showing that literal name as if it were
// an actual package reads as confusing/meaningless to the trainer, so it's relabeled for
// display only here — the underlying package row/data is untouched. Exported so every caller of
// this component agrees on the same display name instead of re-deriving it.
export const displayPackageName = (name) =>
  name === "Predhodne termine" ? "Nema aktivnih paketa" : name;

// The exact package-status control the Members grid card uses (Members/index.js's `MemberCard`)
// — extracted here so any other screen that needs the same "does this member have a usable
// package" summary (New Appointment's own Član section) renders literally this component
// instead of a second implementation. Two states, same as Members' card always had: a
// clickable compact summary when `currentPackage` is given (name + used/total + mini progress
// + valid-until), or a small dashed "Dodeli paket" pill when there isn't one. Either way
// `onClick` is the caller's — Members routes it to PackageDetailsModal, New Appointment routes
// it straight to the existing PackageAssignFlow catalog. `nameOverride` lets a caller swap only
// the displayed name (New Appointment's own "Dodeli paket" trigger reuses this same "has a
// package" card shape even when that package isn't an active one, so the label reads as an
// invite to assign a real one instead of the stale/expired package's actual name) — Members
// itself never passes this, so its own card is completely unaffected.
const MemberPackageStatus = ({
  currentPackage,
  status,
  validUntil,
  usedSessions,
  totalSessions,
  onClick,
  nameOverride,
}) => {
  if (!currentPackage) {
    return (
      <button
        type="button"
        className="hf-mem-badge hf-mem-badge-none hf-mem-badge-clickable"
        onClick={onClick}
      >
        <AddIcon sx={{ fontSize: 13 }} />
        Dodeli paket
      </button>
    );
  }

  return (
    <button
      type="button"
      className={`hf-mem-pkg-btn${
        status === "active" ? "" : " hf-mem-pkg-btn-expired"
      }`}
      onClick={onClick}
    >
      <div className="hf-mem-pkg-btn-top">
        <span className="hf-mem-pkg-btn-name">
          {nameOverride || displayPackageName(currentPackage.package_name)}
        </span>
        <span className="hf-mem-pkg-btn-count">
          {usedSessions}/{totalSessions}
        </span>
      </div>
      <div className="hf-mem-pkg-mini-track">
        <div
          className="hf-mem-pkg-mini-fill"
          style={{
            width: `${
              totalSessions > 0
                ? Math.min(100, Math.round((usedSessions / totalSessions) * 100))
                : 0
            }%`,
          }}
        />
      </div>
      <span className="hf-mem-pkg-btn-valid">
        {/* A pending request has no start/end date yet (see selectCurrentPackage) — nothing
            to format, so it gets its own label instead of "Važi do Invalid date". An already
            *approved* package can hit the exact same gap while it still has no booking of its
            own (start_date/end_date only exist once one's been made) — `validUntil` is then an
            invalid moment even though `status` is "active", so it falls back to the same
            duration-based text PackageDetailsModal's own validityText already uses for that
            case, instead of formatting an invalid date. */}
        {status === "pending"
          ? "Na odobravanju"
          : validUntil && validUntil.isValid()
            ? `${status === "active" ? "Važi do" : "Isteklo"} ${validUntil.format("DD.MM.YYYY")}`
            : validityText(currentPackage)}
      </span>
    </button>
  );
};

export default MemberPackageStatus;
